import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { GetLaunchLabsConfigApi } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const GetLaunchLabsConfig = createAsyncThunk('get/getLaunchLabsConfig', GetLaunchLabsConfigApi);

export const GetLaunchLabsConfigSlice = createSlice({
	name: 'getLaunchLabsConfig',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[GetLaunchLabsConfig.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[GetLaunchLabsConfig.rejected.toString()]: setAPIError,
		[GetLaunchLabsConfig.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;
			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[GetLaunchLabsConfigSlice.name]: ReturnType<typeof GetLaunchLabsConfigSlice.reducer>;
}

export const getLaunchLabsConfigSelector = (state: IStates): any => {
	return state[GetLaunchLabsConfigSlice.name] || {};
};

export const useGetLaunchLabsConfig = (): any => useSelector(getLaunchLabsConfigSelector);

export const triggerGetLaunchLabsConfig =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(GetLaunchLabsConfig(params));
		return;
	};

export const resetGetLaunchLabsConfig =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(GetLaunchLabsConfigSlice.actions.RESET());
		return;
	};
